import { Grid, Tooltip, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useGetScenarioAttemptsQuery } from "../../services/tracking.service";
import { useGetScenesQuery } from "../../services/scene.service";
import { Params, useParams } from "react-router-dom";
import { IScene } from "@virtus-tech-repository/virtus-tech-repository/lib/models/scenario.model";
import { EDraggableOptions } from "@virtus-tech-repository/virtus-tech-repository/lib/models/media.model";
import { useAppSelector } from "../../store/hooks";
import { VTButton, VTHTMLHotspot } from "@virtus-tech-repository/virtus-tech-repository";
import { useGetHotspotsQuery } from "../../services/hotspot.service";
import { IHotspot } from "@virtus-tech-repository/virtus-tech-repository/lib/models/hotspot.model";

import {
    AdsClickRounded,
    VisibilityRounded,
    StartRounded,
    EditNoteRounded,
    ImageRounded,
    PlayCircleRounded,
    HourglassTopRounded,
    ArrowDropDownRounded,
    ArrowRightRounded,
    CheckCircleRounded,
    CancelRounded,
    PlaylistAddCircleRounded,
} from "@mui/icons-material";
import ScoresStopPoint from "./ScoresStopPoint";
import ScoresHotspot from "./ScoresHotspot";
import { ITrackingActions, ITrackingHotspotAction } from "../../models/tracking.models";
import { textCutOffAddElipsis } from "../../helpers/UIHelpers";
import { Background } from "@xyflow/react";

interface IProps {
    sceneActionElement: ITrackingActions;
    scenes: IScene[];
    furtherScenes: boolean;
    showScenes?: boolean;
    marked?: boolean;
    zoomValue?: number;
    answeredStopPoints?: { sceneId: string; questionId: string; correct: boolean }[];
}

export default function VTScoresItem({
    sceneActionElement,
    scenes,
    furtherScenes,
    showScenes = true,
    marked,
    zoomValue = 0.5,
    answeredStopPoints,
}: IProps) {
    const currentSceneElement = scenes.find(
        (sceneFindElement: IScene) => sceneFindElement.id === sceneActionElement.sceneId,
    );
    const theme = useTheme();
    const [showSceneScores, setShowSceneScores] = useState<boolean>(showScenes);

    let sortedHotspotActions: {
        hotspotId: string;
        questionId?: string;
        actions: { action: string; data?: string; date: Date }[];
    }[] = [];

    sceneActionElement.hotspotActions.forEach(
        (hotspotActionElement: ITrackingHotspotAction, index: number) =>
            (hotspotActionElement.questionId ||
                currentSceneElement?.hotspots?.find(
                    (findElement: IHotspot) => findElement.id === hotspotActionElement.hotspotId,
                )) &&
            (index === 0
                ? sortedHotspotActions.push({
                      hotspotId: hotspotActionElement.hotspotId,
                      questionId: hotspotActionElement.questionId,
                      actions: [
                          {
                              action: hotspotActionElement.action,
                              date: hotspotActionElement.date,
                              data: hotspotActionElement.data,
                          },
                      ],
                  })
                : sortedHotspotActions[sortedHotspotActions.length - 1] &&
                  sortedHotspotActions[sortedHotspotActions.length - 1].hotspotId === hotspotActionElement.hotspotId
                ? (sortedHotspotActions[sortedHotspotActions.length - 1] = {
                      hotspotId: hotspotActionElement.hotspotId,
                      questionId: hotspotActionElement.questionId,
                      actions: [
                          ...sortedHotspotActions[sortedHotspotActions.length - 1].actions,
                          {
                              action: hotspotActionElement.action,
                              date: hotspotActionElement.date,
                              data: hotspotActionElement.data,
                          },
                      ],
                  })
                : sortedHotspotActions.push({
                      hotspotId: hotspotActionElement.hotspotId,
                      questionId: hotspotActionElement.questionId,
                      actions: [
                          {
                              action: hotspotActionElement.action,
                              date: hotspotActionElement.date,
                              data: hotspotActionElement.data,
                          },
                      ],
                  })),
    );

    if (currentSceneElement) {
        const dateObject = new Date(sceneActionElement.date);
        return (
            <>
                <Grid sx={{ zoom: zoomValue }} item container justifyContent={"center"}>
                    <Tooltip
                        PopperProps={{ style: { zIndex: 100000 } }}
                        title={
                            <VTButton
                                type={"list"}
                                startIcon={<StartRounded />}
                                endIcon={
                                    <div style={{ marginLeft: "20px" }}>
                                        {dateObject.getHours().toString().length === 1 && "0"}
                                        {dateObject.getHours()}:{dateObject.getMinutes().toString().length === 1 && "0"}
                                        {dateObject.getMinutes()}:
                                        {dateObject.getSeconds().toString().length === 1 && "0"}
                                        {dateObject.getSeconds()}
                                    </div>
                                }
                            >
                                <div style={{ marginLeft: "-10px" }}>Scene Entered</div>
                            </VTButton>
                        }
                        placement={"right"}
                    >
                        <div
                            style={{
                                margin: "-8px",
                                backgroundColor: "#393939",
                                borderRadius: "15px",
                                cursor: "pointer",
                                position: "relative",
                            }}
                        >
                            {marked === true &&
                            (currentSceneElement.mediaType === EDraggableOptions.VIDEO ||
                                currentSceneElement.mediaType === EDraggableOptions.IMMERSIVE_VIDEO) ? (
                                <>
                                    {answeredStopPoints &&
                                    answeredStopPoints.filter(
                                        (filterElement: { sceneId: string; questionId: string; correct: boolean }) =>
                                            filterElement.correct === true,
                                    ).length === 0 ? (
                                        <CancelRounded
                                            sx={{
                                                position: "absolute",
                                                top: "-15px",
                                                right: "-15px",
                                                fontSize: "2.5em",
                                                color: "#D2042D",
                                                backgroundColor: theme.palette.background.default,
                                                borderRadius: "50%",
                                            }}
                                        />
                                    ) : (
                                        <>
                                            {answeredStopPoints &&
                                            answeredStopPoints.filter(
                                                (filterElement: {
                                                    sceneId: string;
                                                    questionId: string;
                                                    correct: boolean;
                                                }) => filterElement.correct === false,
                                            ).length === 0 ? (
                                                <CheckCircleRounded
                                                    sx={{
                                                        position: "absolute",
                                                        top: "-15px",
                                                        right: "-15px",
                                                        fontSize: "2.5em",
                                                        color: "#19c73f",
                                                        backgroundColor: theme.palette.background.default,
                                                        borderRadius: "50%",
                                                    }}
                                                />
                                            ) : (
                                                <PlaylistAddCircleRounded
                                                    sx={{
                                                        position: "absolute",
                                                        top: "-15px",
                                                        right: "-15px",
                                                        fontSize: "2.5em",
                                                        color: "#00FFFF",
                                                        backgroundColor: theme.palette.background.default,
                                                        borderRadius: "50%",
                                                    }}
                                                />
                                            )}
                                        </>
                                    )}
                                </>
                            ) : (
                                <>
                                    {marked === true ? (
                                        <CheckCircleRounded
                                            sx={{
                                                position: "absolute",
                                                top: "-15px",
                                                right: "-15px",
                                                fontSize: "2.5em",
                                                color: "#19c73f",
                                                backgroundColor: theme.palette.background.default,
                                                borderRadius: "50%",
                                            }}
                                        />
                                    ) : (
                                        <CancelRounded
                                            sx={{
                                                position: "absolute",
                                                top: "-15px",
                                                right: "-15px",
                                                fontSize: "2.5em",
                                                color: "#D2042D",
                                                backgroundColor: theme.palette.background.default,
                                                borderRadius: "50%",
                                            }}
                                        />
                                    )}
                                </>
                            )}

                            <img
                                src={
                                    currentSceneElement.mediaType === EDraggableOptions.IMMERSIVE_VIDEO
                                        ? currentSceneElement.src.split(".mp4")[0] + "_preview.jpg"
                                        : `${currentSceneElement?.src}/f.jpg`
                                }
                                height={"100px"}
                                width={"150px"}
                                style={{
                                    borderRadius: "15px 15px 0px 0px",
                                }}
                            />

                            {showSceneScores ? (
                                <ArrowDropDownRounded
                                    sx={{
                                        position: "absolute",
                                        zIndex: 100,
                                        fontSize: "3em",
                                        right: "-8px",
                                        bottom: "-8px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setShowSceneScores(!showSceneScores)}
                                />
                            ) : (
                                <ArrowRightRounded
                                    sx={{
                                        position: "absolute",
                                        zIndex: 100,
                                        fontSize: "3em",
                                        right: "-8px",
                                        bottom: "-8px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setShowSceneScores(!showSceneScores)}
                                />
                            )}

                            {currentSceneElement.mediaType === EDraggableOptions.IMMERSIVE_IMAGE && (
                                <ImageRounded
                                    height={"15px"}
                                    width={"15px"}
                                    style={{
                                        borderRadius: "15px",
                                        position: "absolute",
                                        top: "5px",
                                        left: "5px",
                                        padding: "3px",
                                        background: "rgba(0,0,0,0.5)",
                                    }}
                                />
                            )}

                            {(currentSceneElement.mediaType === EDraggableOptions.IMMERSIVE_VIDEO ||
                                currentSceneElement.mediaType === EDraggableOptions.VIDEO) && (
                                <PlayCircleRounded
                                    height={"15px"}
                                    width={"15px"}
                                    style={{
                                        borderRadius: "15px ",
                                        position: "absolute",
                                        top: "5px",
                                        left: "5px",
                                        padding: "3px",
                                        background: "rgba(0,0,0,0.5)",
                                    }}
                                />
                            )}
                            <Typography
                                align="center"
                                sx={{
                                    marginBottom: "3px",
                                }}
                            >
                                {textCutOffAddElipsis(currentSceneElement.name, 12)}
                            </Typography>
                        </div>
                    </Tooltip>
                </Grid>
                {/* {demoData.actions.length !== index + 1 && ( */}
                {(showSceneScores || furtherScenes) && (
                    <Grid sx={{ zoom: zoomValue }} item container justifyContent={"center"}>
                        <hr
                            style={{
                                color: "#fff",
                                backgroundColor: "#fff",
                                height: "80px",
                                width: "3px",
                            }}
                        />
                    </Grid>
                )}
                {/* )} */}
                {currentSceneElement.hotspots &&
                    showSceneScores &&
                    sortedHotspotActions.map(
                        (
                            sortedHotspotActionElement: {
                                hotspotId: string;
                                questionId?: string;
                                actions: { action: string; data?: string; date: Date }[];
                            },
                            elementIndex: number,
                        ) => {
                            const currentHotspotElement = currentSceneElement.hotspots.find(
                                (hotspotsFindElement: IHotspot) =>
                                    hotspotsFindElement.id === sortedHotspotActionElement.hotspotId,
                            );

                            const currentDataInput: { action: string; data?: string; date: Date } | undefined =
                                sortedHotspotActionElement.actions.find(
                                    (findElement: { action: string; data?: string; date: Date }) => findElement.data,
                                );

                            if (currentHotspotElement) {
                                if (currentHotspotElement.type !== EDraggableOptions.QUESTION) {
                                    return (
                                        <>
                                            <Grid
                                                item
                                                container
                                                justifyContent={"center"}
                                                sx={
                                                    elementIndex % 2 === 0
                                                        ? { paddingLeft: "60px", zoom: zoomValue }
                                                        : { paddingRight: "60px", zoom: zoomValue }
                                                }
                                            >
                                                <Grid item sx={{ position: "relative" }}>
                                                    <hr
                                                        style={{
                                                            color: "#fff",
                                                            backgroundColor: "#fff",
                                                            height: "3px",
                                                            width: "60px",
                                                            marginTop: "-10px",
                                                        }}
                                                    />
                                                    <Grid
                                                        item
                                                        sx={
                                                            elementIndex % 2 === 0
                                                                ? {
                                                                      marginRight: "-180px",
                                                                      marginLeft: "180px",
                                                                      marginTop: "-70px",
                                                                      marginBottom: "-70px",
                                                                      height: "120px",
                                                                      width: "300px",
                                                                      position: "relative",
                                                                  }
                                                                : {
                                                                      marginLeft: "-180px",
                                                                      marginRight: "180px",
                                                                      marginTop: "-70px",
                                                                      marginBottom: "-70px",
                                                                      height: "120px",
                                                                      width: "300px",
                                                                      position: "relative",
                                                                  }
                                                        }
                                                        container
                                                        alignContent={"center"}
                                                        direction={elementIndex % 2 === 0 ? "row" : "row-reverse"}
                                                    >
                                                        {sortedHotspotActionElement.actions.filter(
                                                            (filterElement: {
                                                                action: string;
                                                                data?: string;
                                                                date: Date;
                                                            }) => filterElement.action === "Input",
                                                        ).length > 0 ? (
                                                            <Tooltip
                                                                title={"Data Entry"}
                                                                placement="bottom"
                                                                PopperProps={{ style: { zIndex: 100000 } }}
                                                            >
                                                                <EditNoteRounded
                                                                    sx={
                                                                        elementIndex % 2 === 0
                                                                            ? {
                                                                                  border: "2px solid white",
                                                                                  position: "absolute",
                                                                                  top: "47px",
                                                                                  left: "-43px",
                                                                                  backgroundColor: "#222326",
                                                                                  borderRadius: "50%",
                                                                                  cursor: "pointer",
                                                                                  fontSize: "1.8em",
                                                                              }
                                                                            : {
                                                                                  position: "absolute",
                                                                                  top: "47px",
                                                                                  right: "-43px",
                                                                                  backgroundColor: "#222326",
                                                                                  borderRadius: "50%",
                                                                                  cursor: "pointer",
                                                                                  fontSize: "1.8em",
                                                                              }
                                                                    }
                                                                />
                                                            </Tooltip>
                                                        ) : sortedHotspotActionElement.actions.filter(
                                                              (filterElement: {
                                                                  action: string;
                                                                  data?: string;
                                                                  date: Date;
                                                              }) => filterElement.action === "Clicked",
                                                          ).length > 0 ? (
                                                            <Tooltip
                                                                title={"Clicked"}
                                                                placement="bottom"
                                                                PopperProps={{ style: { zIndex: 100000 } }}
                                                            >
                                                                <AdsClickRounded
                                                                    sx={
                                                                        elementIndex % 2 === 0
                                                                            ? {
                                                                                  position: "absolute",
                                                                                  top: "47px",
                                                                                  left: "-43px",
                                                                                  backgroundColor: "#222326",
                                                                                  borderRadius: "50%",
                                                                                  cursor: "pointer",
                                                                                  border: "2px solid white",
                                                                                  fontSize: "1.8em",
                                                                                  padding: "2px",
                                                                              }
                                                                            : {
                                                                                  position: "absolute",
                                                                                  top: "47px",
                                                                                  right: "-43px",
                                                                                  backgroundColor: "#222326",
                                                                                  borderRadius: "50%",
                                                                                  cursor: "pointer",
                                                                                  border: "2px solid white",
                                                                                  fontSize: "1.8em",
                                                                                  padding: "2px",
                                                                              }
                                                                    }
                                                                />
                                                            </Tooltip>
                                                        ) : (
                                                            <Tooltip
                                                                title={"Hovered"}
                                                                placement="bottom"
                                                                PopperProps={{ style: { zIndex: 100000 } }}
                                                            >
                                                                <VisibilityRounded
                                                                    sx={
                                                                        elementIndex % 2 === 0
                                                                            ? {
                                                                                  position: "absolute",
                                                                                  top: "47px",
                                                                                  left: "-43px",
                                                                                  padding: "2px",
                                                                                  backgroundColor: "#222326",
                                                                                  borderRadius: "50%",
                                                                                  cursor: "pointer",
                                                                                  border: "2px solid white",
                                                                                  fontSize: "1.8em",
                                                                              }
                                                                            : {
                                                                                  position: "absolute",
                                                                                  top: "47px",
                                                                                  right: "-43px",
                                                                                  padding: "2px",
                                                                                  backgroundColor: "#222326",
                                                                                  borderRadius: "50%",
                                                                                  cursor: "pointer",
                                                                                  border: "2px solid white",
                                                                                  fontSize: "1.8em",
                                                                              }
                                                                    }
                                                                />
                                                            </Tooltip>
                                                        )}

                                                        <Tooltip
                                                            title={
                                                                <>
                                                                    {sortedHotspotActionElement.actions.map(
                                                                        (
                                                                            hotspotActionElement: {
                                                                                action: string;
                                                                                data?: string;
                                                                                date: Date;
                                                                            },
                                                                            mapIndex: number,
                                                                        ) => {
                                                                            const dateObject = new Date(
                                                                                hotspotActionElement.date,
                                                                            );

                                                                            if (
                                                                                !sortedHotspotActionElement.actions[
                                                                                    mapIndex - 1
                                                                                ] ||
                                                                                hotspotActionElement.action !==
                                                                                    sortedHotspotActionElement.actions[
                                                                                        mapIndex - 1
                                                                                    ].action
                                                                            ) {
                                                                                return (
                                                                                    <VTButton
                                                                                        type={"list"}
                                                                                        startIcon={
                                                                                            hotspotActionElement.action ===
                                                                                            "Input" ? (
                                                                                                <EditNoteRounded />
                                                                                            ) : hotspotActionElement.action ===
                                                                                              "Clicked" ? (
                                                                                                <AdsClickRounded />
                                                                                            ) : (
                                                                                                <VisibilityRounded />
                                                                                            )
                                                                                        }
                                                                                        endIcon={
                                                                                            <div
                                                                                                style={{
                                                                                                    marginLeft: "20px",
                                                                                                }}
                                                                                            >
                                                                                                {dateObject
                                                                                                    .getHours()
                                                                                                    .toString()
                                                                                                    .length === 1 &&
                                                                                                    "0"}
                                                                                                {dateObject.getHours()}:
                                                                                                {dateObject
                                                                                                    .getMinutes()
                                                                                                    .toString()
                                                                                                    .length === 1 &&
                                                                                                    "0"}
                                                                                                {dateObject.getMinutes()}
                                                                                                :
                                                                                                {dateObject
                                                                                                    .getSeconds()
                                                                                                    .toString()
                                                                                                    .length === 1 &&
                                                                                                    "0"}
                                                                                                {dateObject.getSeconds()}
                                                                                            </div>
                                                                                        }
                                                                                    >
                                                                                        <div
                                                                                            style={{
                                                                                                marginLeft: "-10px",
                                                                                            }}
                                                                                        >
                                                                                            {
                                                                                                hotspotActionElement.action
                                                                                            }
                                                                                        </div>
                                                                                    </VTButton>
                                                                                );
                                                                            }
                                                                        },
                                                                    )}
                                                                </>
                                                            }
                                                            placement={elementIndex % 2 === 0 ? "right" : "left"}
                                                            PopperProps={{ style: { zIndex: 100000 } }}
                                                        >
                                                            <Tooltip
                                                                title={
                                                                    currentDataInput !== undefined
                                                                        ? "User Response: " + currentDataInput.data
                                                                        : ""
                                                                }
                                                                placement="bottom-end"
                                                                disableHoverListener={currentDataInput === undefined}
                                                                PopperProps={{ style: { zIndex: 100000 } }}
                                                            >
                                                                <Grid
                                                                    item
                                                                    sx={{
                                                                        height: "130px",
                                                                        paddingInline: "15px",
                                                                        overflowY: "auto",
                                                                    }}
                                                                    justifyContent={
                                                                        elementIndex % 2 === 0
                                                                            ? "flex-start"
                                                                            : "flex-end"
                                                                    }
                                                                    alignContent={"safe center"}
                                                                    container
                                                                >
                                                                    <ScoresHotspot
                                                                        currentHotspotElement={currentHotspotElement}
                                                                        leftHotspot={elementIndex % 2 !== 0}
                                                                    />
                                                                </Grid>
                                                            </Tooltip>
                                                        </Tooltip>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {(furtherScenes || elementIndex !== sortedHotspotActions.length - 1) && (
                                                <Grid sx={{ zoom: zoomValue }} item container justifyContent={"center"}>
                                                    <hr
                                                        style={{
                                                            color: "#fff",
                                                            backgroundColor: "#fff",
                                                            height: "80px",
                                                            width: "3px",
                                                            marginTop: "-10px",
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                        </>
                                    );
                                } else {
                                    return (
                                        <Grid sx={{ zoom: zoomValue }} item container xs={12} justifyContent={"center"}>
                                            <Grid item container xs={12} justifyContent={"center"}>
                                                <ScoresStopPoint
                                                    currentHotspotElement={currentHotspotElement}
                                                    questionActions={sortedHotspotActionElement.actions}
                                                    sortedHotspotActions={sortedHotspotActions}
                                                    answerHotspots={currentHotspotElement.groupedHotspots!}
                                                    answeredStopPoints={answeredStopPoints}
                                                />
                                            </Grid>
                                            {(furtherScenes ||
                                                elementIndex !==
                                                    sortedHotspotActions.filter(
                                                        (
                                                            filterElement: {
                                                                hotspotId: string;
                                                                questionId?: string;
                                                                actions: {
                                                                    action: string;
                                                                    data?: string;
                                                                    date: Date;
                                                                }[];
                                                            },
                                                            filterIndex: number,
                                                        ) =>
                                                            filterIndex < elementIndex ||
                                                            filterElement.questionId === undefined,
                                                    ).length -
                                                        1) && (
                                                <Grid item container justifyContent={"center"}>
                                                    <hr
                                                        style={{
                                                            color: "#fff",
                                                            backgroundColor: "#fff",
                                                            height: "80px",
                                                            width: "3px",
                                                            marginTop: "-1px",
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                    );
                                }
                            }
                        },
                    )}
            </>
        );
    } else {
        return <></>;
    }
}
